import { jsx as o } from "react/jsx-runtime";
import { useRef as y, useMemo as E } from "react";
import O from "classnames";
import r from "./index.es775.js";
import { TooltipProvider as P } from "@radix-ui/react-tooltip";
import { useEnrichTooltipOpenState as g } from "./index.es128.js";
import { SimpleTooltip as x } from "./index.es127.js";
import { BodyText as B } from "./index.es505.js";
const D = "help-button-component";
function L(e) {
  return e.startsWith("data-");
}
const N = ({
  size: e = "large",
  disabled: t,
  testId: p = D,
  onClick: a,
  tooltipTestId: c,
  tooltip: s = "Learn More",
  isOnGrayBackground: m,
  appendToParent: u = !0,
  ...n
}) => {
  const d = y(null), f = O(r["help-button-root"], [r[`size-${e}`]], {
    [r.disabled]: t,
    [r["on-gray-background"]]: m
  }), { isTooltipOpen: T, enrichTooltipProps: b } = g({ ref: d }), h = E(() => Object.keys(n).reduce((l, i) => (L(i) && (l[i] = n[i]), l), {}), [n]);
  return /* @__PURE__ */ o(P, { children: /* @__PURE__ */ o(
    x,
    {
      open: T,
      title: s,
      testId: c,
      appendToParent: u,
      children: /* @__PURE__ */ o(
        "button",
        {
          className: f,
          onClick: a,
          "aria-label": `${s}` || "help-button",
          "aria-disabled": t,
          disabled: t,
          ...h,
          "data-testid": p,
          ...b,
          children: /* @__PURE__ */ o(B, { color: t ? "disabled" : "primary", children: "?" })
        }
      )
    }
  ) });
};
export {
  D as HELP_BUTTON_DEFAULT_TESTID,
  N as HelpButton
};
//# sourceMappingURL=index.es10.js.map
